import Image from 'next/image';
import { cltw } from 'ui';

interface ICategoryItemProps {
  isSelected: boolean;
  onClick: () => void;
  image: string;
  label: string;
}

const CategoryItem = ({
  isSelected,
  onClick,
  image,
  label,
}: ICategoryItemProps) => {
  return (
    <div className='flex cursor-pointer flex-col items-center'>
      <div
        className={cltw(
          'size-20 flex-shrink-0 rounded-lg border bg-gray-50 p-2 hover:border-black md:size-28',
          isSelected && 'border-black',
        )}
        onClick={onClick}
      >
        <Image
          height={200}
          width={200}
          src={image}
          alt={'Band Category'}
          className='aspect-square object-contain md:w-32'
          draggable='false'
        />
      </div>
      <p
        key={label}
        className={cltw(
          isSelected ? 'font-semibold' : 'font-normal',
          'py-1 text-center text-xs md:text-sm',
        )}
      >
        {label}
      </p>
    </div>
  );
};

export default CategoryItem;
